import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

/**
 * AdminLayout \u2014 outlet-only shell.
 *
 * As of 2026-07-15 pm, the Admin sub-modules are surfaced on the
 * sidebar (hover flyout when navigation is elsewhere; inline expanded
 * list when the current route is inside /admin). The on-page tab bar
 * that used to live here was retired at Fernando's request so the
 * whole page area is available for sub-page content.
 *
 * If a future coming-soon module needs a UI hint on the /admin index,
 * add it below. For now, hitting /admin bare redirects to
 * /admin/agents via the router.
 */
export default function AdminLayout() {
  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
